import { BaseStateFieldType } from '@navstation-portal/reporting/data-model/vessel-report';
import { EntityId } from '@navstation-portal/shared/data-model/common';
import { OffshoreBunkerState } from './bunker/offshore-bunker.state';
import { OffshoreConsumptionsState } from './consumptions/offshore-consumptions.state';
import { OffshoreFormConfig } from './offshore-form-config';
import { OffshoreOperationalState } from './operational/offshore-operational.state';
import { OffshorePositionAndWeatherState } from './position-and-weather';
import { OffshoreStockState } from './stock/offshore-stock.state';

export interface ApiReportResponse {
  report_id: string;
  event: string;
  operation: string;
  status: 'complete' | 'draft';
  period_from: string;
  period_to: string;
  timezone: string;
  created: string;
  updated: string;
  fields: IOffshoreReport;
}

export interface IOffshoreReportWithId {
  reportId: EntityId;
  report: IOffshoreReport;
}

export interface OffshoreReportState {
  readonly fetchingReport: boolean;
  readonly creatingReport: boolean;
  readonly savingReport: boolean;
  readonly formConfig: OffshoreFormConfig | null;
}

export type AnyOffshoreSectionState =
  | OffshoreOperationalState
  | OffshorePositionAndWeatherState
  | OffshoreConsumptionsState
  | OffshoreBunkerState
  | OffshoreStockState;

export interface IOffshoreReport {
  readonly operational?: OffshoreOperationalState;
  readonly positionAndLogistics?: OffshorePositionAndWeatherState;
  readonly consumptions?: OffshoreConsumptionsState;
  readonly stock?: OffshoreStockState;
  readonly bunker?: OffshoreBunkerState;
}

export const INITIAL_OFFSHORE_REPORT_STATE: OffshoreReportState = {
  fetchingReport: false,
  creatingReport: false,
  savingReport: false,
  formConfig: null,
};

export type OffshoreReportData = Record<
  string,
  Record<string, BaseStateFieldType | Record<string, BaseStateFieldType>>
>;

export const OFFSHORE_EVENT_TYPES = {
  SEA: 'sea',
  ARRIVAL: 'arrival',
  MANEUVERING: 'maneuvering',
  PORT: 'port',
  ANCHOR: 'anchor',
  DRIFTING: 'drifting',
  DYNAMIC_POSITIONING: 'dynamic_positioning',
  STANDBY_ON_LOCATION: 'standby_on_location',
  CANAL_TRANSIT: 'canal_transit',
  DRY_DOCK_REPAIR: 'dry_dock_repair',
  DEPARTURE: 'departure',
};

export type OffshoreEventType = (typeof OFFSHORE_EVENT_TYPES)[keyof typeof OFFSHORE_EVENT_TYPES];

export const OffshoreEventTypes = Object?.values(OFFSHORE_EVENT_TYPES ?? {});
